module.exports = __webpack_public_path__ + "static/media/DBHeavent.b5c8bc60.ttf";